import { render, staticRenderFns } from "./ItemPurchase.vue?vue&type=template&id=dcb6f0dc"
import script from "./ItemPurchase.vue?vue&type=script&lang=js"
export * from "./ItemPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports